import { FC } from "react";
import { NavLink } from "react-router";
import { isMobile } from "react-device-detect";

const AboutNavigation: FC = () => {
  const navItems = [
    { path: "/about", label: "О компании", end: true },
    { path: "/about/terms", label: "Условия использования" },
    { path: "/about/privacy", label: "Конфиденциальность" },
  ];

  return (
    <nav
      className={`flex ${
        isMobile
          ? "flex-row overflow-x-auto py-2 mb-4 gap-2 whitespace-nowrap"
          : "flex-col rounded-2xl h-max bg-white p-4  min-w-[370px] shadow"
      }`}
    >
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.end}
          className={({ isActive }) =>
            `${
              isMobile ? "text-base px-3 py-2" : "text-xl py-2"
            } font-medium cursor-pointer transition-colors ${
              isActive
                ? "text-[#383181]"
                : "text-gray-600 hover:text-[#383181]"
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default AboutNavigation;